var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "c-form",
      attrs: {
        action: _vm.autocompleteUrl,
        method: "get",
        "accept-charset": "utf-8",
      },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.search.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "c-form__item c-form__item--text" }, [
        _c("input", {
          ref: "searchInput",
          class: {
            "c-form__input": true,
            "is-empty": !_vm.keyword,
            "is-open": _vm.isOpen,
          },
          attrs: {
            type: "text",
            id: "autocomplete-" + parseInt(Math.random() * 1000),
            name: "search",
            autocomplete: "off",
            placeholder: _vm.inputPlaceholder,
          },
          domProps: { value: _vm.keyword },
          on: {
            input: _vm.onInput,
            focus: _vm.showForm,
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.redirectToSearch.apply(null, arguments)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "c-btn is-search",
          class: {
            "is-loading": _vm.isLoading,
            "is-open": _vm.isOpen,
            "c-btn--primary": _vm.isBabys,
            "c-btn--secondary": !_vm.isBabys,
          },
          attrs: {
            href: `/vyhladavanie${_vm.keyword ? `?search=${_vm.keyword}` : ""}`,
          },
        },
        [_c("i", { staticClass: "ico ico-search" })]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "c-btn is-close",
          class: {
            "is-loading": _vm.isLoading,
            "is-open": _vm.isOpen,
          },
          attrs: { type: "button" },
          on: { click: _vm.hideForm },
        },
        [
          _c("i", {
            staticClass: "ico ico-close",
            attrs: { "aria-hidden": "true" },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }